import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  drawerPaper: {
    marginTop: ({ isModeDraft }) => theme.typography.pxToRem(isModeDraft ? 193 : 137),
    width: theme.typography.pxToRem(500),
    [theme.breakpoints.down('xs')]: {
      marginTop: ({ isModeDraft }) => theme.typography.pxToRem(isModeDraft ? 168 : 112),
      width: '100%',
    },
  },
  drawerContainer: ({ isActive, isModeDraft }) => ({
    display: `${isActive ? 'flex' : 'none'}`,
    height: `calc(100vh - ${theme.typography.pxToRem(isModeDraft ? 193 : 137)})`,
    overflow: 'auto',
    [theme.breakpoints.down('xs')]: {
      height: `calc(100vh - ${theme.typography.pxToRem(isModeDraft ? 168 : 112)})`,
    },
  }),
  drawerHeader: {
    display: 'flex',
    alignItems: 'start',
    justifyContent: 'space-between',
    padding: theme.spacing(3),
    background: theme.palette.background.default,
    position: 'sticky',
    top: '0',
    zIndex: '1350',
  },
  drawerContent: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(5),
    paddingInline: theme.spacing(3),
  },
}));

export default useStyles;
